/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const SearchAlert = [
  ["circle", { cx: "11", cy: "11", r: "8" }],
  ["path", { d: "m21 21-4.3-4.3" }],
  ["path", { d: "M11 7v4" }],
  ["path", { d: "M11 15h.01" }]
];

export { SearchAlert as default };
//# sourceMappingURL=search-alert.js.map
